import {computed, makeObservable} from 'mobx'
import {injectable} from 'inversify'
import {ApiResponse} from 'back-connector'

import {BaseDataStore} from '@/stores/shared/BaseDataStore'
import {TerminalType} from '@/constants'

import {StoreType} from '../types'
import {fetchAllStoresOfMerchant} from '../api'
import {convertStoresToSelectItems} from '../utils'

@injectable()
export class AllStoresDataStore extends BaseDataStore<StoreType[]> {
    get hasPosStores() {
        return this.data.some(({type}) => type === TerminalType.POS)
    }

    get storesAsSelectItems() {
        return convertStoresToSelectItems(this.data)
    }

    constructor() {
        super()

        makeObservable(this, {
            ...this.getAnnotationsMap(),
            hasPosStores: computed,
            storesAsSelectItems: computed
        })
    }

    protected async fetchData(): Promise<ApiResponse<StoreType[]>> {
        return fetchAllStoresOfMerchant()
    }

    protected getDefaultData(): StoreType[] {
        return []
    }
}
